import React from 'react';
import CantSignIn from './CantSignIn';

const CantSignInContainer = () => {
  return <CantSignIn />;
};

export default CantSignInContainer;
